import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import { ClaimCyclePvDetailsReportLineContainerModel, ClaimCycleAuditTrailContainer} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimCyclePvDetailsReportLineService extends BaseApiTemplateService<ClaimCyclePvDetailsReportLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/backoffice-ep';

    this.httpClient = http;
  }

  generatePvReportLines(claimCycleGuid: any, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/generation/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/generation/backoffice-ep';
    }

    return this.httpClient.post(url, claimCycleGuid, this.getHttpHeader(visa));
  }

  generatePvReportLinesMultiple(bodyRequest: any, apiVisa: ApiVisa): Observable<BasicApiResponseModel<ClaimCyclePvDetailsReportLineContainerModel>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/history/multiple-companies/backoffice-ep';
    if (apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/history/multiple-companies/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCyclePvDetailsReportLineContainerModel>>(url, bodyRequest, this.getHttpHeader(apiVisa));
  }

  auditTrailExport(bodyRequest: any, apiVisa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/audit-trail-export/backoffice-ep';
    if (apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleAuditTrailContainer>>(url, bodyRequest, this.getHttpHeader(apiVisa));
  }

  auditTrailExportSummary(bodyRequest: any, apiVisa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/summary/audit-trail-export/backoffice-ep';
    if (apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/summary/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleAuditTrailContainer>>(url, bodyRequest, this.getHttpHeader(apiVisa));
  }

  auditTrailExportForMultipleCompanies(bodyRequest: any, apiVisa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/multiple-companies/audit-trail-export/backoffice-ep';
    if (apiVisa.api_domain_url) {
      url = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-report-lines/pv-details-report-lines/multiple-companies/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimCycleAuditTrailContainer>>(url, bodyRequest, this.getHttpHeader(apiVisa));
  }
}
